<template>
	<div class="job-results">
		<Loading v-if="loading" text="Die Jobs werden geladen..."/>
		<template v-else-if="items !== null">
			<NoMatches
				v-if="showDataCompletionBox"
				title="Wir sind auf der Suche nach deinem persönlichen Best-Match."
			>
				<div v-if="!hasMatches">
					<b>Wenn du aktuell keine Matches siehst, mach dir keine Sorgen, das ist ganz normal.</b>
				</div>
				<div v-if="!hasMatches" class="mt-1">
					skilldoo müllt dich nicht mit unpassenden Jobangeboten zu, sondern zeigt dir ausschließlich deine
					Top-Matches. Wir informieren dich per E-Mail, sobald es einen passenden Match gibt.
				</div>
				<div class="mt-3">
					Um deine Chancen zu erhöhen, ergänze noch folgende Punkte:
				</div>
				<div class="no-matches--content-button-container">
					<Button
						v-if="!application.dataCompletion.skills.completed"
						text="Meine Skills"
						smaller
						href="/kandidat/profil/kompetenzen"
					/>
					<Button
						v-if="!application.dataCompletion.education.completed"
						text="Meine Ausbildung"
						smaller
						href="/kandidat/profil/lebenslauf"
					/>
				</div>
			</NoMatches>
			<JonInfo v-if="!hasMatches && onlyExcluded">
				<template #message>
					Du hast derzeit keine ausgeschlossenen Jobs.
				</template>
			</JonInfo>
			<div v-if="hasMatches" class="job-results--items">
				<Pagination
					v-model="page"
					:page="page"
					:total="meta.total"
					:items-per-page="itemsPerPage"
					class="mb-4"
					@input="load"
				/>
				<ListItem
					v-for="listItem in items"
					:key="listItem.id"
					:job="job"
					:item="listItem"
					@addExclusion="remove(listItem)"
					@removeExclusion="load"
					@remove="remove(listItem)"
					@messagesClosed="$emit('messagesClosed')"
				/>
				<Pagination
					v-model="page"
					:page="page"
					:total="meta.total"
					:items-per-page="itemsPerPage"
					class="mt-4"
					@input="load"
				/>
			</div>
		</template>
	</div>
</template>
<script>
import Loading from "@/vue/common/Loading";
import Listing from "@/api/job/Listing";
import ListItem from "./ListItem";
import Button from "@/vue/common/Button";
import Pagination from "@/vue/common/Pagination"
import NoMatches from "@/vue/common/NoMatches.vue";
import JonInfo from "@/vue/common/JonInfo.vue";
import {mapState} from "vuex";
import {arrayIsNotEmpty} from "@/helper/Array";

export default {
	components: {
		JonInfo,
		NoMatches,
		Loading,
		Button,
		ListItem,
		Pagination,
	},

	props: {
		job: {
			type: Object,
			required: true,
		},
		filterValues: {
			type: Array,
			required: false,
		},
		onlyFavorites: {
			type: Boolean,
			required: false,
			default: false
		},
		onlyExcluded: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	mounted ()
	{
		this.load();
	},

	data ()
	{
		return {
			loading: false,
			items: null,
			meta: null,
			page: 1,
			itemsPerPage: 10,
		};
	},

	computed: {
		...mapState('auth', ['application']),
		hasMatches ()
		{
			return arrayIsNotEmpty(this.items);
		},
		showDataCompletionBox ()
		{
			if (this.onlyExcluded || !this.application)
			{
				return false;
			}

			return !this.application.dataCompletion.completed;
		}
	},

	methods: {
		remove ()
		{
			this.load();
		},
		async load ()
		{
			this.loading = true;

			const response = await new Listing()
				.setJob(this.job.id)
				.setFilterValues(this.filterValues)
				.setOnlyFavorites(this.onlyFavorites)
				.setOnlyExcluded(this.onlyExcluded)
				.setOffset((this.page - 1) * this.itemsPerPage)
				.setLimit(this.itemsPerPage)
				.call();

			this.items = response.data.items;
			this.meta = response.meta;

			this.$emit('loaded', {
				totalCount: this.meta.total,
			});

			this.loading = false;
		}
	},

	watch: {
		filterValues ()
		{
			this.page = 1;

			this.load();
		},
		onlyFavorites ()
		{
			this.page = 1;

			this.load();
		}
	}
}
</script>
